<mat-label class="labelOnLeft" for="start" *ngIf="labelsOnLeft">{{labelFrom}}</mat-label>

<ng-container *ngIf="!readonly; else readonlycomponent">

  <mat-form-field class="styledmobilitycompany mobilitycompany-mat-no-subscript" appearance="fill" floatLabel="always">
    <mat-label for="fromDate" *ngIf="!labelsOnLeft">{{labelFrom}}</mat-label>


    <mat-datepicker-toggle matPrefix [for]="datePickerStart"></mat-datepicker-toggle>
    <input matInput (click)="datePickerStart.open()" (dateChange)="onChangeFromDate($event)" [matDatepicker]="datePickerStart"
      [readonly]="true" [min]="minDate" [max]="maxDate ? maxDate: fromDateMaxDate" [formControl]="fromDateControl"
           [disabled]="disabled"
      required
           name="fromDate"
    >

    <mat-datepicker #datePickerStart [disabled]="disabled"></mat-datepicker>

  </mat-form-field>

</ng-container>

<ng-template #readonlycomponent>
  <mat-form-field class="styledmobilitycompany mobilitycompany-mat-no-subscript" appearance="fill" floatLabel="always">
    <mat-label for="toDate" *ngIf="!labelsOnLeft">{{labelFrom}}</mat-label>

    <input matInput [matDatepicker]="datePickerEnd" [readonly]="true" [min]="minDate" [max]="maxDate ? maxDate: fromDateMaxDate"
      [formControl]="fromDateControl" required name="toDate"
           [disabled]="disabled">

    <mat-datepicker #datePickerEnd [disabled]="disabled"></mat-datepicker>
  </mat-form-field>
</ng-template>




<mat-label class="labelOnLeft" for="start" *ngIf="labelsOnLeft">{{labelTo}}</mat-label>


<ng-container *ngIf="!readonly; else readonlycomponentExpire">
  <mat-form-field class="styledmobilitycompany mobilitycompany-mat-no-subscript" appearance="fill" floatLabel="always"
    *ngIf="!readonly">
    <mat-label for="expiry" *ngIf="!labelsOnLeft">{{labelTo}}</mat-label>
    <mat-datepicker-toggle matPrefix [for]="expiry" [disableRipple]="true"></mat-datepicker-toggle>
    <input matInput (click)="expiry.open()" (dateChange)="onChangeToDate($event)" [readonly]="true"
      [matDatepicker]="expiry" [min]="minDate ? minDate: toDateMinDate" [max]="maxDate" [formControl]="toDateControl"
      required
           [disabled]="disabled">
    <mat-datepicker #expiry [disabled]="disabled"></mat-datepicker>
    <div matSuffix></div>
  </mat-form-field>
</ng-container>

<ng-template #readonlycomponentExpire>
  <mat-form-field class="styledmobilitycompany mobilitycompany-mat-no-subscript" appearance="fill" floatLabel="always"
    *ngIf="!readonly">
    <mat-label for="expiry" *ngIf="!labelsOnLeft">{{labelTo}}</mat-label>
    <input matInput [readonly]="true" [matDatepicker]="expiry" [min]="minDate ? minDate: toDateMinDate" [max]="maxDate"
      [formControl]="toDateControl" required
           [disabled]="disabled">


    <mat-datepicker #expiry [disabled]="disabled"></mat-datepicker>
  </mat-form-field>
</ng-template>
